export enum StatusTypes {
    InProgress = "inprogress",
    Done = "done",
    Cancelled = "cancelled",
    Error = "error"
}